import type { PersonDetail } from "@/api/db/people";

type Conflict = PersonDetail["conflicts"][number];
type Divergence = PersonDetail["divergences"][number];

export interface FieldProblem {
	conflicts: Conflict[];
	divergences: Divergence[];
}

export function fieldProblems(person: PersonDetail) {
	const map: Record<string, FieldProblem> = {};

	const bucket = (field: string) => (map[field] ??= { conflicts: [], divergences: [] });

	for (const conflict of person.conflicts) {
		bucket(conflict.field).conflicts.push(conflict);
	}

	for (const divergence of person.divergences) {
		bucket(divergence.field).divergences.push(divergence);
	}

	return map;
}
